import React from 'react'
import { Header } from 'pages/Header';
import { Footer } from 'pages/Footer';
import { decodeStorage } from 'functions/storageBase64';
import { useDispatch } from 'store';
import { setLoginRedirectSSO } from 'util/navigation';
import Styles from './styles.module.sass'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CintilloMonederoSears = () => (
    <section className='headBandNew'>
      <a href="https://blogmimesaderegalosears.com/" target="_blank" className='headBandLink' rel="noreferrer">
        <span className="contentBandNew">
          <span className="firstText">Gana $25,000 pesos en monedero electrónico.</span>
          <span className="lastText">Cuéntanos tu historia de amor</span>
        </span>
      </a>
    </section>
)

const HeroSection = ({ isLoggedIn }) => {
    const date = new Date()
    const homeBackground = `https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/mesa-original-v1.jpeg?ttl=${date.getFullYear()}${date.getMonth()}${date.getDate()}`

    return(
        <section
            className="NewSectionTitle"
            style={{ backgroundImage: `url(${homeBackground})` }}
        >
          <div className='contBtnsMesa'>
            <a className="link-button" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
              <div className="primaryButton btn btn-primary btn-block">
                Crear mesa de regalos
              </div>
            </a>
            <a className="link-button" href='/Mesa-de-Regalos/buscar-evento'>
              <div className="secondaryButton btn btn-primary btn-block">
                Buscar mesa de regalos
              </div>
            </a>

            <a className="link-button" href={setLoginRedirectSSO('my-table', true, isLoggedIn, true)}>
              <div className="thirdButton linkBtn btn btn-primary btn-block">
                ¿Eres el festejado?
                <span>Entrar a mi mesa</span>
              </div>
            </a>

          </div>
        </section>
    )
}

const ModuleBeneficios = (props) => {
    const {
        contBeneficio
    } = props

    return(
        <div className={Styles?.contentBeneficts}>
            <img className={Styles?.imageBen} src={contBeneficio?.img} alt={contBeneficio?.title} />
            <p className={Styles?.h2}>{contBeneficio?.title}</p>

            <ul className={Styles?.benefictsIcons}>
                {contBeneficio?.eventos.map((evento, index) => (
                    <li key={index}>
                        <img className={Styles?.iconEvents} src={evento?.ico} alt={evento?.title} />
                        {evento?.title}
                    </li>
                ))}
            </ul>

            <p className={Styles?.titlePoints}>Beneficios</p>
            <ul className={Styles?.benefictsPoints}>
                {contBeneficio?.beneficios.map((beneficio, index) => (
                    <li key={index} dangerouslySetInnerHTML={{__html: beneficio}}></li>
                ))}
            </ul>

            <ul className={Styles?.benefictsPeros}>
                {contBeneficio?.peros.map((pero, index) => (
                    <li key={index}>{pero}</li>
                ))}
            </ul>
        </div>
    )
}

const SectionEvents = () => {

    const celebracion = {
        img: '/img/nuevaMesa/celebracion.png',
        title: 'CELEBRACIÓN',
        eventos: [
            {ico: '/img/nuevaMesa/boda.svg', title: 'Boda'},
            {ico: '/img/nuevaMesa/baby_shower.svg', title: 'Baby shower'},
            {ico: '/img/nuevaMesa/generico.svg', title: 'Bautizo'},
            {ico: '/img/nuevaMesa/XV_anios.svg', title: 'XV Años'},
            {ico: '/img/nuevaMesa/generico.svg', title: 'Primera comunión'}
        ],
        beneficios: [
            'Recibe tus regalos en casa con <strong>envío GRATIS</strong> o recibe un monedero SEARS.',
            'Los invitados podrán comprar los regalos en tienda o en linea.',
            'Recibe hasta el <strong>5% ó 10% de bonificación</strong> sobre tus compras.*',
            'Todos los eventos te dan <strong>regalos de bienvenida.**</strong>',
            'Notificaciones en tiempo real.',
            '<strong>Personaliza tu mesa</strong> con fotografías, mensajes para tus invitados y notas de agradecimiento.',
            'Servicio sin costo.',
            'Al cerrar tu Mesa de Regalos recibirás un obsequio. ***',
        ],
        peros: [
            '    * Consulta marcas y departamentos participantes con tu asesora en tienda.',
            '  ** Con un mínimo de compra de $500.00 MXN.',
            '*** Aplica para compras mínimas de $5,000.00 MXN.'
        ]
    }

    const todaOcacion = {
        img: '/img/nuevaMesa/toda_ocacion.png',
        title: 'TODA OCASIÓN',
        eventos: [
            {ico: '/img/nuevaMesa/despedida.svg', title: 'Despedidas'},
            {ico: '/img/nuevaMesa/casa_nueva.svg', title: 'Casa nueva'},
            {ico: '/img/nuevaMesa/cumpleanios_adulto.svg', title: 'Cumpleaños adulto'},
            {ico: '/img/nuevaMesa/generico.svg', title: 'Cumpleaños infantil'},
            {ico: '/img/nuevaMesa/graduacion.svg', title: 'Graduación'},
            {ico: '/img/nuevaMesa/aniversario.svg', title: 'Aniversario'},
            {ico: '/img/nuevaMesa/dia_especial.svg', title: 'Día especial'},
        ],
        beneficios: [
            'Recibe tus regalos en casa con <strong>envío GRATIS</strong> o recibe un monedero SEARS.',
            'Los invitados podrán comprar los regalos en tienda o en linea.',
            'Notificaciones en tiempo real.',
            '<strong>Personaliza tu mesa</strong> con fotografías, mensajes para tus invitados y notas de agradecimiento.',
            'Servicio sin costo.',
            'Al cerrar tu Mesa de Regalos recibirás un obsequio. *',
        ],
        peros: [
            '* Aplica para compras mínimas de $5,000.00 MXN'
        ]
    }

    return(
        <section>
            <div className={Styles?.moduleTitleBeneficts}>
                <h1>Festeja cualquier evento especial, tu graduación, nuevo hogar, bautizos... en fin.</h1>
                <p>¡Tenemos la mesa digital perfecta para que tu evento sea inolvidable!</p>
            </div>

            <div className={Styles?.contSectionBeneficios}>
                <ModuleBeneficios contBeneficio={celebracion} />
                <ModuleBeneficios contBeneficio={todaOcacion}  />
            </div>

            <div className={Styles?.newGiftTable}>

                <div className={Styles?.cardNewGT}>
                    <p className={Styles?.titleCardNGT}>La Mesa de Regalos se renueva para ti.</p>
                    <p className={Styles?.phaCardNGT}>A partir de este momento podrás disfrutar los grandes beneficios que Sears te ofrece.</p>
                    <p className={Styles?.phaCardNGT}>Decide como recibir tus obsequios con <strong>nuestro plan hibrido</strong>; de forma virtual o hasta la puerta de tu hogar sin ningún costo.</p>
                    <p className={Styles?.phaCardNGT}>Además, <strong>compartir tu mesa</strong> de regalos será́ mucho más fácil por medio de <strong>código QR, link o tus redes sociales</strong>.</p>
                </div>
                <div className={Styles?.contImgNewGT}>
                    <img src="/img/nuevaMesa/renovacion.png" alt="Nueva Mesa de Regalos" className={Styles?.imgNewGT} />
                </div>
            </div>

        </section>
    )
}

const SectionSteps = () => {

    const steps = {
        title: '¡Así de fácil es crear una Mesa de Regalos!',
        pasos: [
            {ico: '/img/nuevaMesa/step_1.svg', title: 'Elige un tipo de evento'},
            {ico: '/img/nuevaMesa/step_2.svg', title: 'Elige un plan'},
            {ico: '/img/nuevaMesa/step_3.svg', title: 'Selecciona tus regalos'},
            {ico: '/img/nuevaMesa/step_4.svg', title: 'Comparte tu mesa con tus invitados'},
            {ico: '/img/nuevaMesa/step_5.svg', title: 'Cierre de evento'}
        ],
        sliderImages: [
            '/img/nuevaMesa/banner_Recuerda.png',
            '/img/nuevaMesa/banner_Recuerda.png',
        ]
    }

    const settings = {
        dots: true,
        autoplay: true,
        infinite: true,
        dotsClass: Styles?.dotsSliders,
        className: Styles?.slideSliders,
        centerMode: false,
        swipe: true,
        touchMove: true,
        slidesToShow: 1,
        adaptiveHeight: true,
        speed: 700,
        responsive: [
            {
                breakpoint: 780,
                settings: {
                    autoplay: true,
                    infinite: true,
                    centerMode: false,
                    swipe: true,
                    touchMove: true,
                    adaptiveHeight: true,
                    slidesToShow: 1,
                    speed: 700,
                }
            }
        ]
    };

    return(
        <section>
            <div className={Styles?.contSteps}>
                <p>{steps?.title}</p>
                <ul className={Styles?.stepsList}>
                    {steps?.pasos.map((paso, index) => (
                        <li key={index}>
                            <div>
                                <img src={paso?.ico} alt={paso?.title} />
                                <div className={Styles?.textSteps}>
                                    {index+1}.
                                    <span>{paso?.title}</span>
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>

            <div className={Styles?.contSlider}>
                <Slider {...settings}>
                    {
                        steps?.sliderImages.map((img, index) => (
                            <img key={index} src={img} alt={`Paso ${index}`} importance="low" loading="lazy" />
                        ))
                    }
                </Slider>
            </div>
        </section>
    )
}

const Home = () => {

    const [isLogged] = decodeStorage('session_token');
    const dispatch = useDispatch();
    const isLoggedIn = !!(isLogged && isLogged.length);

    return(
        <>
            <Header type="complete" />
            <main className="gifts-root">

                <CintilloMonederoSears />
                
                <HeroSection isLoggedIn={isLoggedIn} />
                
                <SectionEvents />

                <SectionSteps />

            </main>
            <Footer type="complete" />
        </>
    )
}

export default Home;